import React from "react";

const ListComponent = ({ keyValue, value, breakLine, icon }) => {
  return (
    <div style={{ padding: '6px 0' }} className={`order-list ${breakLine ? "list-break-line" : ""}`}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }} className="order-key">
        {icon}
        <p style={{ fontWeight: '600', fontSize: '14px' }}>{keyValue}</p>
      </div>
      <div className="order-value">
        <p style={{ fontWeight: '700', fontSize: '14px' }}>{value}</p>
      </div>
    </div>
  );
};

export default ListComponent;
